// extracted by mini-css-extract-plugin
module.exports = {"offline":"offline_offline__3kjeg"};